import { Stack, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Link } from "react-router-dom";

type BreadcrumbItem = {
  label: string;
  to?: string;
  disabled?: boolean;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
};

const Breadcrumb = ({ items }: BreadcrumbProps) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {items.map((item, index) => (
        <Stack key={index} direction="row" spacing={1} alignItems="center">
          {index > 0 && <ChevronRightIcon />}
          {item.to && !item.disabled ? (
            <Typography
              variant="h5"
              fontWeight="bold"
              component={Link}
              to={item.to}
              sx={{ color: "primary.main", textDecoration: "none" }}
            >
              {item.label}
            </Typography>
          ) : (
            <Typography
              variant="h5"
              fontWeight="bold"
              color={item.disabled ? "text.disabled" : "text.primary"}
            >
              {item.label}
            </Typography>
          )}
        </Stack>
      ))}
    </Stack>
  );
};

export default Breadcrumb;
